import { Modal, ModalBody, ModalFooter } from '../common/Modal'
import { Button } from '../common/Button'

interface SystemInfoModalProps {
  isOpen: boolean
  onClose: () => void
}

export function SystemInfoModal({ isOpen, onClose }: SystemInfoModalProps) {
  const systemInfo = {
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    environment: import.meta.env.MODE,
    buildTime: import.meta.env.VITE_BUILD_TIME || 'N/A',
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="System Information" size="sm">
      <ModalBody>
        <dl className="space-y-3">
          <div className="flex justify-between">
            <dt className="text-text-muted">Version:</dt>
            <dd className="font-medium text-text">{systemInfo.version}</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-text-muted">Environment:</dt>
            <dd className="font-medium text-text capitalize">{systemInfo.environment}</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-text-muted">Build Time:</dt>
            <dd className="font-medium text-text">{systemInfo.buildTime}</dd>
          </div>
        </dl>
      </ModalBody>
      <ModalFooter>
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default SystemInfoModal
